import CreateMicroscopyFigureButton from "./CreateMicroscopyFigureButton";
import { useDispatch } from 'react-redux';
import { useReducer} from 'react';
import TemplateCreator from './TemplateCreator';
import getDefaultChannels from './getDefaultChannels';


const defaultStructure = [["A","B","C","D"]];

const colorOrder = ["red","green","blue","cyan","magenta","yellow"];


const defaultChannels = Object.fromEntries(["R","G","B"].map((channelId,ii) => {
  return [channelId,{
    color:colorOrder[ii],
    label:colorOrder[ii],
    defaultValue:(ii+1)
  }]
}))

const __defaultTemplate = {
  channelGroupStructure:defaultStructure,
  channelGroups:{
    A:["R"],
    B:["G"],
    C:["B"],
    D:["R","G","B"]
  },
  regionLocation:"none",
  textLocation:"none",
  channels:defaultChannels,

  regions:[],
  //scalebar



  text:[{ 
    all:{ 
      location:"tl",
      label:"Label", 
      style:{
        background:"black",
        fontWeight:"bold",
      },
      functions:{ "style.color":"=channelColor" }
    },
  }],
  scalebarLocation:"none",
}

function TemplateReducer(state,action){
  return {
    ...state,
    compact:{
      ...state.compact,
      ...action
    }
  }
}



export default function MicroscopyPanelSpecification({
  setSelectedFigurePanelContext, 
  setTargetDirectoryOfNewFigurePanel, 
  targetDirectoryOfNewFigurePanel
}){

  let dispatch = useDispatch();
  const [ template, templateDispatch ] = useReducer(TemplateReducer,{compact:__defaultTemplate});


  let createFigureButton = (
    <div class="fair-margin-top">
      <CreateMicroscopyFigureButton 
        {...{ 
          template:template.compact, 
          setTargetDirectoryOfNewFigurePanel 
        }}
      />
    </div>
  )


  /*
  const _id = Id();

  dispatch(A.createItem({
    type:FIGURE_PANELS,
    figurePanelType:'microscopy',
    _id,
    args:{
      compactTemplate:template
    },
    onSuccess:[
      A.setSelectedFigurePanelContext({
        context:{
          _id,
          figurePanelId:_id
        }
      })
    ]
  }))
  */



  return (
    <div class="">
      <div class="sg-col flex-expand h-center" style={{
        minHeight:0,
      }}>
    {true && <TemplateCreator 
          template={template} 
          templateDispatch={templateDispatch} 
        />}
        <div style={{marginTop:40, textAlign:'center'}} class="fair-margins sg-row h-center">
          {createFigureButton}
        </div>
      </div>

    </div>
  )


  /*
  let x = false && (


        <MicroscopyCropInsertion {...{
          useCase:"figureCreation",
          //defaultTemplate,
          onSubmit:(({compactTemplate,annotationId}) => {
            //create figure
            //that has the given template as 'initTemplate'
            //AND
            //the cell inserted.
   

            const _id = Id();
            dispatch(A.createItem({
              type:FIGURE_PANELS,
              figurePanelType:'microscopy',
              _id,
              args:{
                compactTemplate
              },
              onSuccess:[
                A.setSelectedFigurePanelContext({
                  context:{
                    _id,
                    figurePanelId:_id
                  }
                })
              ]
            }))

            dispatch(A.setCellsValue({
              figurePanelId:_id,
              cells:[[2,1]],
              value:{ 
                valueType:"crop",
                annotationId
              }
            }))

            setTargetDirectoryOfNewFigurePanel(false);
          })

        }}/>

  )


*/







}
